
import { Injectable } from '@angular/core';
import { Http, Response, Headers, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { CONFIGURATION } from '../app.config';

@Injectable()
export class SharpNewHireService {
    private sharpNewHireUrl = CONFIGURATION.baseServiceUrl + 'sharp-new-hire/';
    private _ssnUrl = CONFIGURATION.baseServiceUrl + 'SsnInfo/';

    constructor(private _http: Http) { }


    getReferenceData(): Observable<any> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.get(this.sharpNewHireUrl + 'reference-data', { headers: headers })
            .map((response: Response) => response.json().sharpnewHireReferenceDataVO)
            .catch(this.handleError);
    }

    countByWeek(filterCriteria: any): Observable<any> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        let fileName: string = 'count-by-week?WorkYear=' + filterCriteria.selectedYear
            + '&WorkMonth=' + filterCriteria.selectedHireMonth
            + '&ControlGroup=' + filterCriteria.selectedControlGroup;
        return this._http.get(this.sharpNewHireUrl + fileName, { headers: headers })
            .map((response: Response) => response.json().summaryCountForSharpNewHireVO)
            .catch(this.handleError);
    }

    getReportData(filterCriteria: any): Observable<any> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        let fileName: string = 'report-data?WorkYear=' + filterCriteria.selectedYear
            + '&WorkMonth=' + filterCriteria.selectedHireMonth
            + '&ControlGroup=' + filterCriteria.selectedControlGroup;
        return this._http.get(this.sharpNewHireUrl + fileName, { headers: headers })
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }

    downloadExcelReport(filterCriteria: any): any {
        let fileName = 'excel-download?WorkYear=' + filterCriteria.selectedYear
            + '&WorkMonth=' + filterCriteria.selectedHireMonth
            + '&ControlGroup=' + filterCriteria.selectedControlGroup;

        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.get(this.sharpNewHireUrl + fileName, { headers: headers, responseType: ResponseContentType.Blob }).map(
            (res) => {
                const a = document.createElement('a');
                document.body.appendChild(a);
                const blob = new Blob([res.blob()], { type: 'application/zip' });
                const downloadUrl = URL.createObjectURL(blob);
                window.open(downloadUrl);
            })
    }

    private handleError(error: Response) {
        // in a real world app, we may send the server to some remote logging infrastructure
        // instead of just logging it to the console
        console.error(error);
        return Observable.throw(error.json().error || 'Failed in web api(Server error) ');
    }

    getSSnData(ssnData: any): Observable<any[]> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        let fileName = 'ssnreportdata?Ssn=' + ssnData.ssn
            + '&TaxYear=' + ssnData.taxyear
            + '&ControlGroup=' + ssnData.controlgroup
            + '&ReportName=' + 'SharpNewHiresReport';
        return this._http.get(this._ssnUrl + fileName, { headers: headers })
            .map((response: Response) => <any[]>response.json())
            .catch(this.handleError);
    }

}



// WEBPACK FOOTER //
// ./src/app/sharp-new-hire-report/sharp-new-hire-report.service.ts